<!--
  @component ProjectsHome — the Liquid Studio landing (account home).
  tier:      screen (account-level — `/projects`, post-login home)
  reads:     useIdentityIO (ready gate) · mounts the block canvas + wizard.
  shape:     a composable block canvas (hero · stats · carousel · feed ·
             schedule · grid). Blocks read their own data; this screen owns the
             ready-state gate, the New-project wizard, and the shared actions.
-->
<script lang="ts">
  import { useIdentityIO } from "../accounts/IdentityIO.svelte";
  import NewProjectWizard from "../wizards/NewProjectWizard.svelte";
  import { provideHomeActions } from "../home/home-context.js";
  import HomeCanvas from "../home/HomeCanvas.svelte";
  import Skeleton from "../../../global/visuals/primitives/Skeleton.svelte";

  const identity = useIdentityIO();

  let wizardOpen = $state(false);
  provideHomeActions({ openNewProject() { wizardOpen = true; } });
</script>

<div class="home">
  {#if !identity.ready}
    <div class="sk" aria-busy="true">
      <Skeleton variant="line" width="100%" height="232px" radius="var(--radius-xl, 18px)" />
      <div class="sk-row sk-4">
        {#each Array.from({ length: 4 }) as _, i (i)}
          <Skeleton variant="line" width="100%" height="78px" radius="var(--radius-lg, 14px)" />
        {/each}
      </div>
      <div class="sk-row sk-tiles">
        {#each Array.from({ length: 4 }) as _, i (i)}
          <Skeleton variant="line" width="100%" height="188px" radius="var(--radius-lg, 14px)" />
        {/each}
      </div>
    </div>
  {:else}
    <HomeCanvas />
  {/if}
</div>

<NewProjectWizard open={wizardOpen} onClose={() => (wizardOpen = false)} />

<style>
  .home { max-width: 1200px; font-family: var(--type-font); }
  .sk { display: flex; flex-direction: column; gap: var(--space-5); }
  .sk-row { display: grid; gap: var(--space-4); }
  .sk-4 { grid-template-columns: repeat(4, 1fr); }
  .sk-tiles { grid-template-columns: repeat(4, 1fr); }
  @media (max-width: 900px) {
    .sk-4 { grid-template-columns: repeat(2, 1fr); }
    .sk-tiles { grid-template-columns: repeat(2, 1fr); }
  }
</style>
